module.exports = __webpack_public_path__ + "static/media/stevie-g.6affb33b.png";